<script setup lang="ts">
import { processError } from "~/lib/utils/errors";
import { defineSeo } from "~/lib/utils/seo";

const omniaSdk = useOmniaSdk();

const { data, error } = await useAsyncData(`content-133072`, async () => {
  try {
    return await omniaSdk.v1.contents.get(parseInt(useRuntimeConfig().public.tutorialId));
  } catch (error) {
    processError(error);
  }
});

if (error.value) {
  processError(error.value);
}

defineSeo({
  title: data.value.title,
});
</script>

<template>
  <FrontBreadcrumHero :search="false" :breadcrumbs="[{ title: data.title }]"></FrontBreadcrumHero>
  <div class="main-content">
    <div class="lg:grid grid-cols-8 gap-10 xl:gap-20">
      <div class="col-start-2 col-span-6 mb-16 lg:mb-0">
        <h1 class="text-4xl font-extrabold mt-5">{{ data.title }}</h1>
        <!-- RIASSUNTO -->
        <div
          class="mt-8 print:mt-4 mb-8 print:mb-6 prose max-w-full font-semibold text-lg print:text-base print:italic print:font-normal prose-a:text-primary"
          v-if="data.abstract?.length"
          v-html="data.abstract?.replace(/\n/g, '<br>')"
        ></div>

        <div class="mb-8">
          <div class="mt-5">
            <FrontContentBodyWithFiles :text="data.body" />
          </div>
        </div>
      </div>
    </div>

    <AdminLinkToAdmin :config="{ content: data }" />
  </div>
</template>
